<template>
  <div class="flex flex-row gap-3">
    <div
      @click="handleClickTab('report_summary')"
      :class="[
        'p-2  rounded shadow flex-1 flex justify-center items-center cursor-pointer',
        {
          'bg-brand/20 hover:bg-brand hover:text-white text-brand border border-brand/30': selectedRightSectionTab !== 'report_summary',
          'bg-brand text-white ': selectedRightSectionTab === 'report_summary',
        },
      ]"
    >
      <p
        class="text-xs font-medium uppercase text-center"
      >
        Report Summary
      </p>
    </div>
    <div
      @click="handleClickTab('my_videos')"
      :class="[
        'p-2  rounded shadow flex-1 flex justify-center items-center cursor-pointer',
        {
          'bg-brand/20 hover:bg-brand hover:text-white text-brand border border-brand/30': selectedRightSectionTab !== 'my_videos',
          'bg-brand text-white ': selectedRightSectionTab === 'my_videos',
        },
      ]"
      v-if="false"
    >
      <p
        class="text-xs font-medium uppercase text-center"
      >
        My Videos
      </p>
    </div>
    <div
      @click="handleClickTab('events_and_reminders')"
      :class="[
        'p-2  rounded shadow flex-1 flex justify-center items-center cursor-pointer',
        {
          'bg-brand/20 hover:bg-brand hover:text-white text-brand border border-brand/30': selectedRightSectionTab !== 'events_and_reminders',
          'bg-brand text-white ':
            selectedRightSectionTab === 'events_and_reminders',
        },
      ]"
    >
      <p
        class="text-xs font-medium uppercase text-center"
      >
        Events & Reminders
      </p>
    </div>
  </div>
</template>

<script setup>
import { useHomeTabsStore } from "@/stores/home/useHomeTabs.store";
import { storeToRefs } from "pinia";

const homeTabStore = useHomeTabsStore();
const { selectedRightSectionTab } = storeToRefs(homeTabStore);

const handleClickTab = (tab) => {
  selectedRightSectionTab.value = tab;
};
</script>

<style lang="scss" scoped></style>
